import * as React from 'react';
import { Tree } from 'primereact/tree';

const LogFilesView = (props) => {
    return (
        <div>
            <Tree
                style={{ width: "100%" }}
                selectionMode="single"
                value={props.treeLogNodes}
                selectionKeys={props.selectionKeys}
                onSelectionChange={e => props.handleSelectionChange(e.value)}
                onContextMenu={props.onContextMenu}
                expandedKeys={props.expandedKeys}
                onToggle={props.onToggle}
            />
        </div>
    )
}

export default LogFilesView;
